import styled, { css } from 'styled-components'

const TermsAgreeWrap = styled.div<{borderRadius: string}>`
  max-width: 458px;
  width: 100%;
  margin: 10px auto 14px auto;
  border: 3px solid #d3d7e4;
  border-radius: ${props => props.borderRadius ?? '5px'};
  @media all and (max-width: 492px) {
    width: 93%;
  }
`

const TermsAgreeContents = styled.div`
  display: block;
  margin: 0px auto;
  @media all and (max-width: 492px) {
    width: 94%;
  }
`

const AllTermsContainer = styled.div<{ active: boolean, checkColor: string }>`
  display: flex;
  width: 100%;
  max-width: 200px;
  height: 20px;
  line-height: 20px;
  margin: 15px 0 0 10px;
  gap: 9px;
  cursor: pointer;
  > span {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: ${(props) => (props.active ? props.checkColor : '#ddd')};
    border-radius: 100px;
    text-align: center;
  }
  @media all and (max-width: 492px) {
    margin: 15px 0 0 0;
  }
`
const EachTermsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 425px;
  width: 100%;
  gap: 12px;
  margin: 20px auto 30px auto;
  @media all and (min-width: 492px) {
    margin: 20px auto 30px 15px;
  }
`

const EachTermsItems = styled.div`
  display: flex;
  width: 100%;
  line-height: 16px;
  gap: 10px;
  cursor: pointer;
  @media all and (max-width: 360px) {
    width: 100%;
  }
`

const CheckIcon = styled.i<{ primary?: boolean; active?: boolean, checkColor: string }>`
  min-width: 14px;
  width: 14px;
  height: 7px;
  margin: 2px 0;
  line-height: 16px;
  border: 2px solid ${(props) => (props.active ? props.checkColor : '#ddd')};
  border-top: 0;
  border-right: 0;
  transform: rotate(-45deg);
  ${props =>
    props.primary &&
    css`
      margin: 4.5px;
      display: flex;
      width: 12px;
      height: 6px;
      border: 1px solid white;
      border-top: 0;
      border-right: 0;
    `}
`

export {
  TermsAgreeWrap,
  TermsAgreeContents,
  AllTermsContainer,
  EachTermsContainer,
  EachTermsItems,
  CheckIcon,
}
